import { PageContext as f } from "@fcamna/shared-component-foundations";
import { useContext as a, useState as d, useRef as x, useEffect as z } from "react";
const g = (n, t = 1) => {
  const e = a(f), [m, o] = d(t), r = x(!1), u = x(1);
  return z(() => {
    const c = e.current.zIndex, I = () => {
      u.current = t > c ? t - c : 1, e.current.zIndex = c + u.current, r.current = !0, o(e.current.zIndex);
    }, s = () => {
      e.current.zIndex = Math.max(c - u.current, 0), r.current = !1, o(e.current.zIndex);
    };
    return n && !r.current ? I() : !n && r.current && s(), () => {
      !n && r.current && s();
    };
  }, [t, n, e]), m;
};
export {
  g as u
};
